import type { ButtonSize } from '../Button'

export const buttonGroupSizes = ['sm', 'md', 'lg'] as const
export type ButtonGroupSize = (typeof buttonGroupSizes)[number]

export const buttonGroupDisplays = ['inline', 'stacked'] as const
export type ButtonGroupDisplay = (typeof buttonGroupDisplays)[number]

export const buttonGroupSizeMap: Record<ButtonGroupSize, ButtonSize> = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
}

export type ButtonGroupArgs = {
  size?: ButtonGroupSize
  display?: ButtonGroupDisplay
}
